import { TextField } from '@hangar/web-components/core/TextField';
import { SearchOutlined } from '@hangar/react-icons/core/interaction/SearchOutlined';
import * as S from './FlightChangesCases.styles';

const AWB_INPUT_ID = 'flight-cases-awb-filter-input';

export interface FlightChangesCasesAwbFilterProps {
    value: string;
    onChange: (next: string) => void;
    labelKey: string;
    placeholderKey: string;
    t: (key: string) => string;
}

export const FlightChangesCasesAwbFilter = ({
    value,
    onChange,
    labelKey,
    placeholderKey,
    t,
}: FlightChangesCasesAwbFilterProps) => {
    const placeholder = t(placeholderKey);

    return (
        <S.FilterFieldColumn data-testid="flight-cases-awb-filter">
            <TextField
                id={AWB_INPUT_ID}
                label={t(labelKey)}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                startIcon={SearchOutlined}
                cleanable
                lang="es"
                data-testid="flight-cases-awb-filter-input"
            />
        </S.FilterFieldColumn>
    );
};
